function ProductImage(props: any) {
  return (
    <div className={`d-flex justify-content-center align-items-center flex-shrink-0 loop-image-product${props.size ? "-" + props.size : ""} ${props.className}`}>
      {!props.src ? null : (
        <img src={props.src} style={{
          objectFit: 'contain',
          maxWidth: '100%',
          maxHeight: '100%'
        }} />
      )}
      {props.badge ? (
        <span className="badge">{props.badge}</span>
      ) : null}
    </div>
  );
}

export default Object.assign({}, {
  ProductImage
})
